<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="abbrs">
<h1 class="ctfm"><a class="page" id="pviii"></a><a class="page" id="pix"></a><a class="xref" href="#/ChiLeong0006#toc">Abbreviations</a></h1>
<table style="border-bottom:0;">
<tbody><tr>
<td>
<p class="td"><abbr>BL</abbr></p>
</td>
<td>
<p class="td">British Library, London</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>Bodleian</abbr></p>
</td>
<td>
<p class="td">Bodleian Library, Oxford</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CUL</abbr></p>
</td>
<td>
<p class="td">Cambridge University Library, Cambridge</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>Folger</abbr></p>
</td>
<td>
<p class="td">Folger Shakespeare Library, Washington, DC</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>Glasgow</abbr></p>
</td>
<td>
<p class="td">Glasgow University Library, Glasgow</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>Huntington</abbr></p>
</td>
<td>
<p class="td">Henry E. Huntington Library, San Marino, California</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>NLM</abbr></p>
</td>
<td>
<p class="td">National Library of Medicine, Bethesda, Maryland</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>NYAM</abbr></p>
</td>
<td>
<p class="td">New York Academy of Medicine Library, New York City, New York</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>NYPL</abbr></p>
</td>
<td>
<p class="td">New York Public Library, New York City, New York</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>OED</i></abbr></p>
</td>
<td>
<p class="td"><i>Oxford English Dictionary Online</i>, ed. J. Simpson and E. Weiner (Oxford, 2003)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>Oxford DNB</i></abbr></p>
</td>
<td>
<p class="td"><i>Oxford Dictionary of National Biography Online</i>, ed. H. C. G. Matthew and B. Harrison (Oxford, 2004)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>RCP</abbr></p>
</td>
<td>
<p class="td">Royal College of Physicians Library, London</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>RCS</abbr></p>
</td>
<td>
<p class="td">Royal College of Surgeons Library, London</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>STC</i></abbr></p>
</td>
<td>
<p class="td">A. W. Pollard and G. R. Redgrave, <i>A Short-Title Catalogue of Books Printed in England, Scotland, and Ireland and of English Books Printed Abroad, 1475–1640</i>, 2nd ed., rev. by K. F. Pantzer, 3 vols. (London, 1976–91)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>Wellcome</abbr></p>
</td>
<td>
<p class="td">Wellcome Library for the History and Understanding of Medicine, London</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>Wing</i></abbr></p>
</td>
<td>
<p class="td">D. Wing, <i>Short-Title Catalogue of Books Printed in England, Scotland, Ireland, Wales and British America and of English Books Printed in Other Countries, 1641–1700</i>, 2nd ed., 3 vols. (New York: Index Committee of the Modern Language Association of America, 1972–94)</p>
</td>
</tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chi-Leong-0007.vue?c28272f2